module.exports = __webpack_public_path__ + "img/avatar.4a5941a7.svg";